import blankAction from '../assets/images/bbBlankAction.png'
import getAction from './getAction'

export default function getCombatantLastRoundAction(combatant, maxCA) {
  for (let actionNum = maxCA; actionNum >= 1; actionNum--) {
    const imageField = 'ca' + actionNum
    const nameField = 'ca_name' + actionNum
    const typeField = 'ca_type' + actionNum

    if (
      combatant[typeField] == 'action' &&
      combatant[nameField] != 'pending' &&
      combatant[nameField] != 'blank'
    ) {
      return {
        image: combatant[imageField],
        name: combatant[nameField],
        action: getAction(combatant[nameField]) ?? null,
      }
    }
  }

  return {
    image: blankAction,
    name: 'blank',
    action: null,
  }
}
